// NavbarElements.js

import styled from 'styled-components'
import { Link } from "gatsby-plugin-react-intl"
import ArrowImage from "../../images/arrow-right.inline.svg"
import ArrowLong from "../../images/arrow-long.inline.svg"

import CloseSVG from "../../images/close.inline.svg"
import WaSVG from "../../images/Socials/wa.inline.svg"
import TwitterSVG from "../../images/Socials/twitter.inline.svg"
import FbSVG from "../../images/Socials/fb.inline.svg"
import EmailSVG from "../../images/Socials/email.inline.svg"

export const Nav = styled.nav `
  height: 90px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 16px;
  padding-right: 16px;
  z-index: 3;
  background: rgba(25,24,24,1);
  &:after {
    content: "";
    display: block;
    height: 1px;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    transition: background-color .5s ease;
    left: 0;
    width: 100%;
  }
`

export const NavButton = styled.div `
  height: 46px;
  border-radius: 40px;
  border: 2px solid #fff;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: 15px;
  position: relative;
  transition: color .5s ease,border-color .5s ease;
  cursor: pointer;
  text-decoration: none;
`

export const Scroll = styled.div `
  position: fixed;
  bottom: 18px;
  left: 16px;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  font-weight: 600;
  transition: opacity .5s ease;
  cursor: default;
  text-transform: uppercase;
  opacity: ${({ active }) =>
      active
        ? 0
        : 1};
`

export const LanguageSwitch = styled.div `
  position: fixed;
  bottom: 25px;
  right: 16px;
  font-size: 16px;
  display: flex;
  font-weight: 600;
  transition: opacity .5s ease;
  cursor: pointer;
  opacity: ${({ active }) =>
      active
        ? 0
        : 1};
  pointer-events: ${({ active }) =>
      active
        ? "none"
        : "all"};
`

export const Arrow = styled(ArrowImage) `
  margin-right: 8px;
  width: 16px;
`

export const ArrowRotated = styled(ArrowImage) `
  margin-right: 8px;
  width: 16px;
  transform: rotate(-45deg);
`

export const ArrowDown = styled(ArrowLong) `
  margin-right: 13px;
  margin-top: 2px;
  width: 32px;
  height: auto;
  transform: rotate(90deg);
`

export const ArrowUp = styled(ArrowImage) `
  width: 32px;
  transform: rotate(-90deg);
`

export const ShareBox = styled.div`
  display: flex;
  align-items: center;
  z-index: 99;
  padding: 0;
  top: 0;
  left: 0;
  height: 90px;
  flex-direction: column;
  position: fixed;
  width: 100%;
  justify-content: flex-start;
  background-color: rgba(25,24,24,1);
  border-bottom: 1px solid #fff;
  text-transform: uppercase;
  transition: transform .3s ease-in-out;
  transform: ${props => (props.open ? "translateX(200%)" : "translateX(0%)")};
  top: ${props => (props.open ? "-100%" : "0")};
  }
`

export const Close = styled(CloseSVG) `
  width: 16px;
  fill: white;
`

export const Wa = styled(WaSVG) `
  width: 16px;
  fill: white;
`
export const Twitter = styled(TwitterSVG) `
  width: 16px;
  fill: white;
`
export const Fb = styled(FbSVG) `
  width: 16px;
  fill: white;
`

export const Email = styled(EmailSVG) `
  width: 16px;
  fill: white;
`